import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { APICore } from '../helpers/api/apiCore';
import { login } from "../helpers/authHelper";

import ErrorBoundary from '../components/ErrorBoundary';

type PrivateRouteProps = {
    component: React.ComponentType,
    roles?: string,
};

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: RouteComponent, ...rest }: PrivateRouteProps) => {
    const location = useLocation();
    const { pathname } = location;
    const api = new APICore();

    const { auth } = useSelector((state) => ({
        auth: state.Auth.user,
    }));

    /**
     * not logged in so redirect to login page with the return url
     */
    if (!api.isUserAuthenticated()) {
        // return <Navigate to={'/account/login'} state={{ from: location }} replace />;
        const stringUrl = ['/dashboard/project', '/dashboard'];
        const containUrl = stringUrl.includes(pathname);

        if (!containUrl) {
            localStorage.setItem('lastUrl', pathname);
        }

        login()
            .then((res) => {
                console.log("success")
                return
            })
            .catch((err) => {
                console.error(err)
                return
            })


    }
    // check if route is restricted by role
    if (auth && !rest.whoCanAccess.includes(auth?.user_type)) {
        // if (roles && roles.user_type.indexOf(roles.user_type) === -1 && !roles.is_delete.includes('no')) {
        return <Navigate to={'/unauthorized-access'} replace />
    }


    return (
        <ErrorBoundary>
            <RouteComponent {...auth} replace />
        </ErrorBoundary>
    )
};

export default PrivateRoute;
